/**
 * Ordena e classifica os pacotes vindos da loja.
 *
 * A loja devolve os planos em ordem arbitraria. Mostrar o anual primeiro nao e
 * detalhe: no iOS existe UMA oferta introdutoria por grupo, para sempre — se a
 * confeiteira clicar no mensal por ser o primeiro, ela nunca mais ve o anual
 * como novidade. Aqui nao usamos oferta, mas a mesma logica vale para a decisao:
 * o plano de maior compromisso precisa ser visto antes.
 */
export function organizarPlanos(pacotes) {
  const ehAnual = (p) =>
    (p.periodo || '').toUpperCase().includes('ANNUAL') ||
    /anual|annual|year/i.test(`${p.id} ${p.produto}`);

  const anual = pacotes.find(ehAnual) || null;
  const mensal = pacotes.find((p) => !ehAnual(p)) || null;

  // Economia so e afirmada quando os dois precos numericos existem. Sem isso
  // ficariamos anunciando um desconto que nao sabemos calcular.
  let economia = null;
  if (anual?.preco && mensal?.preco) {
    const pct = Math.round((1 - anual.preco / (mensal.preco * 12)) * 100);
    if (pct > 0) economia = pct;
  }
  return { anual, mensal, economia, lista: [anual, mensal].filter(Boolean) };
}
